module.exports = __webpack_public_path__ + "media/activity-level/cavapoo-lazy-bones-5a0721cd.svg";